import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import MenuListing from "./Menulisting";
import useAllStores from "hooks/useCurrentUserStores";
import CreateNewMenuModal from "./CreateMenuModal";
import useLinkUnlinkStoreWithMenu from "./hooks/useLinkUnlinkStoreWithMenu";
import useGetMenus from "./hooks/useGetMenus";
import LinkStoresWithMenu from "./LinkStoreMenuModal";
import { useMenuContext } from "store/contexts/Menus";
import useGetMenuInfo from "./hooks/useGetMenuInfo";
import CloneMenu from "./CloneMenuModal";
import EditMenu from "./EditMenuModal";
import AppContainer from "components/ui/AppContainer";
import AppButton from "components/ui/AppButton";
import MenuEditor from "features/menus/containers/MenuEditor";


const Menus = ({ as="page", onSaveAndContinue }) => {
  const { t } = useTranslation();
  const { menuState, updateState } = useMenuContext();
  const { stores, setLoading, loading } = useAllStores();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const [cloneMenuId, setCloneMenuId] = React.useState(null);
  const [menuId, setMenuId] = React.useState(null);
  const [mode,setMode] = React.useState("list"); // create, edit, delete
  const getAllMenus = useGetMenus({ setLoading, updateState });
  const { linkMenu } = useLinkUnlinkStoreWithMenu({
    setLoading,
    updateState,
    selectedStores: menuState?.linkedStores,
    getAllMenus: getAllMenus,
    menuId: menuState?.menuInfo?._id,
  });
  const getMenuById = useGetMenuInfo();
  React.useEffect(() => {
    if(mode === "list") {
      getAllMenus();
    } 
  }, [mode]);

  const footer = (
    <div className="flex justify-end">
      <AppButton onClick={() => onSaveAndContinue?.()}>
        {t("Save & Continue")}
      </AppButton>
    </div>
  );

  if(as=="component" && mode !=="list") {
    return <MenuEditor as="component" menuId={menuId} setCurrentMode={setMode} />;
  }

  return (
    <AppContainer title={t('Manage Menus')} subTitle={t('Organize your store’s offerings. Create categories and add items to build a clear and easy-to-browse menu.')} loading={loading || isLoading} footer={onSaveAndContinue ? footer : null} containerProps={{ className: "overflow-y-hidden" }}>

        <LinkStoresWithMenu
          {...{
            updateState,
            stores,
            loading,
            linkMenu,
          }}
          menuState={menuState}
        />
        <CreateNewMenuModal
          {...{
            updateState,
            stores,
            loading,
            getAllMenus,
            setLoading,
            menuState,
          }}
        />

        <div className="flex min-h-0 flex-1 flex-col w-full overflow-hidden">
          <MenuListing
            as={as}
            setCurrentMode={setMode}
            {...{
              menus: menuState.addedMenus,
              getMenuById,
            }}
            setMenuId={setMenuId}
            CreateNewMenu={() => {
              updateState("isCreateNewMenuModalOpen", true);
            }}
            setOpen={(val, menuId) => {
              getMenuById(menuId);
              updateState("isLinkMenuWithStoresModalOpen", true);
            }}
            setCloneMenuId={setCloneMenuId}
          />
        </div>

      <CloneMenu {...{ menuState, updateState, cloneMenuId }} />
      <EditMenu {...{ menuState, updateState }} />

    </AppContainer>
  );
};

export default Menus;
